import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { wrapFraction } from "@aprao/common/src/math/wrapFraction.js";
import { makeAutoObservable } from "mobx";

import type {
  InterestCalculationType,
  InterestFormulation,
  InterestPayoutType,
  InterestRatePeriod,
  ShapeInterest,
  ShapeInterestRate,
} from "../../shapes/ShapeLender.js";

class InterestRateFacade {
  constructor(readonly $model: ShapeInterestRate) {
    makeAutoObservable(this);
  }

  get rateMargin() {
    return wrapFraction(this.$model.rateMargin);
  }

  get ratePeriod() {
    return this.$model.ratePeriod;
  }

  set rateMargin(rateMargin: BigFraction | null) {
    this.$model.rateMargin = rateMargin?.toFraction() ?? null;
  }

  set ratePeriod(ratePeriod: InterestRatePeriod) {
    this.$model.ratePeriod = ratePeriod;
  }
}

export class InterestFacade {
  constructor(readonly $model: ShapeInterest) {
    makeAutoObservable(this);
  }

  get formulation() {
    return this.$model.formulation;
  }

  get calculationType() {
    return this.$model.calculationType;
  }

  get payoutType() {
    return this.$model.payoutType;
  }

  get definedAmount() {
    return wrapFraction(this.$model.definedAmount);
  }

  get definedAllowance() {
    return wrapFraction(this.$model.definedAllowance);
  }

  get rate() {
    return new InterestRateFacade(this.$model.rate);
  }

  set formulation(formulation: InterestFormulation) {
    this.$model.formulation = formulation;
  }

  set calculationType(type: InterestCalculationType) {
    this.$model.calculationType = type;
  }

  set definedAmount(definedAmount: BigFraction | null) {
    this.$model.definedAmount = definedAmount?.toFraction() ?? null;
  }

  set payoutType(type: InterestPayoutType) {
    this.$model.payoutType = type;
  }

  set definedAllowance(definedAllowance: BigFraction | null) {
    this.$model.definedAllowance = definedAllowance?.toFraction() ?? null;
  }
}
